import { useMemo } from 'react';

export const useNavConfig = () => {
  return useMemo(
    () => [
      {
        title: 'Página inicial',
        path: environment.subPath || '/',
      },
    ],
    []
  );
};
